(() => {
  function init() {
    document.querySelectorAll('#hiropon-campaign').forEach(root => {
      if (root.dataset.hpInitialized) return;
      root.dataset.hpInitialized = 'true';
      const launchAt = Date.parse(root.dataset.hpLaunch);
      const now = () => Date.now();
      function update() {
        if (!Number.isFinite(launchAt) || now() < launchAt) return;
        root.querySelectorAll('[data-hp-product-url]').forEach(link => {
          link.setAttribute('href', link.dataset.hpProductUrl);
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
        });
        root.querySelectorAll('[data-hp-availability]').forEach(label => { label.hidden = true; });
        clearInterval(timer);
      }
      const timer = setInterval(update, 1000);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
